import { useCallback } from 'react'

// The DOM id every FR-58 gate's action targets. Owned here, not by
// WrittenFeedbackCard, so a gate never needs to import a component just to
// learn what to focus. WrittenFeedbackCard imports THIS id instead, and wires
// it onto the toggle's native input via uikit's overrides escape hatch.
export const WRITTEN_FEEDBACK_TOGGLE_ID = 'written-feedback-toggle'

// FR-58's gates all point the same place: the written-feedback toggle at the
// top of every sub-tab. That toggle is reachable from any pane because the
// Feedback collection block renders persistently above whichever sub-tab is
// active (R1 sec 0.1) — so "Turn it on" is a focus move on the SAME page, not
// a navigation to another one.
//
// v67's own gates get this wrong: their link inherits `pointer-events:none`
// from the faded card around it, so it is dead exactly when it's shown (R1
// gap 6). A real `document.getElementById` lookup rather than a ref, because
// the toggle and the gate that focuses it can live in different panes and
// therefore different component subtrees with no ref to share.
export const useFocusWrittenFeedbackToggle = (): (() => void) =>
  useCallback(() => {
    document.getElementById(WRITTEN_FEEDBACK_TOGGLE_ID)?.focus()
  }, [])
